import { StyleConfig } from "@chakra-ui/react";

export const Link: StyleConfig = {
  baseStyle: {
    fontWeight: "semibold",
    color: "blue.500",
  },
};
